export const VIDEO_TUTORIAL_URL = 'https://www.youtube.com/embed/vKdcoKPoxTM';

export const TRIAL_ADVISOR = {
  name: 'Sylwia',
  email: 'sylwia@chatbeat.com',
  calendly: 'https://calendly.com/sylwia_chatbeat/intro',
} as const;

export const PAID_ADVISOR = {
  name: 'Ula',
  email: 'ula@chatbeat.com',
  calendly: 'https://calendly.com/ula-chatbeat',
} as const;
